import React, { useEffect } from 'react'
import styles from './About.module.scss'

const DataSources = () => {
  // const history = useHistory()

  return (
    <div className={styles.containerDiv}>
      <div className={styles.firstContainer}>
      <div className={styles.bottomPadded2}>
          
      <h4>Machine learning - Ensemble methods</h4>
          <p>
          Ensemble methodology is the machine learning approach used to forecast Flu, RSV, and COVID-19 activity. The ensemble method combines multiple forecasting models into one optimal predictive model. This technique facilitates greater prediction stability by minimizing sources of error, including variance, noise, and bias, from the base models. The blended output will produce more accurate predictions for improved decision-making. 
          </p>

         
       <h4>Data Source</h4>
       <p>A centralized repository that incorporates data from a large national payer, including all primary claim platforms. It provides up to ten years of claims, provider, financial management, product, plan, & benefit, customer, consumer/ member, and clinical data.</p>
        
        <h4>Incidence Rate</h4>
        <p>Surveillance and forecasting of disease incidence in the weekly time interval for any given region, is defined as rate: (# of new disease cases / total # of members receiving care) x 100  </p>
          
        <h4>Epiweek</h4>  
        <p>An epidemiological week, commonly referred to as an epiweek, is simply a standardized method of counting weeks to allow for the comparison of data year after year. The first epi week of the year ends, by definition, on the first Saturday of January, if it falls at least four days into the month. Each epiweek begins on a Sunday and ends on a Saturday.</p>
          
          <h4>Horizons</h4>
          <p>Horizon ‘N’ (N being 1, 2…4) indicates ‘N’ step ahead forecast. As the forecast generates up to 4 weeks/steps ahead, all epiweeks (except the initial and latest epiweeks) are forecasted 4 times. </p>
         

          <h4>Moving Epidemic Method (MEM) Threshold Levels </h4>
          <p>The Moving Epidemic Method (MEM) uses patterns from multiple past seasons to establish baseline activity and epidemic thresholds. By analyzing these historical seasonal trends, MEM identifies when current activity rises above normal and enters low/minimal, moderate, high, or very high intensity levels. This approach is especially effective for Flu and RSV, which show reliable and consistent seasonal cycles year after year.   </p>
         
        
          <h4>Quantiles Threshold Levels  </h4>
          <p>For COVID-19, allergy and air quality, and other respiratory virus conditions without stable or repeatable seasonal patterns, thresholds are derived from statistical percentiles (quantiles) computed from recent historical surveillance data (depending on data availability). Current or forecasted activity levels are classified by mapping observed values to these percentile‑defined cutoffs, to delineate low/minimal, moderate, high, and very high intensity. </p>

        </div>
      </div>
      <div className={styles.secondContainer}>
      <div className={styles.bottomPadded2}>
      

        <h4>Flu </h4>
        <p>Cases are identified from adjudicated medical claims, based on positive laboratory test results, procedures, and specific ICD-10 diagnosis codes associated with influenza.</p>
        
        <h4>COVID-19</h4>
        <p>Cases are identified from adjudicated medical claims, based on positive laboratory test results, procedures, and specific ICD-10 diagnosis codes associated with COVID-19.  </p>

        <h4>RSV</h4>
        <p> Cases are identified from adjudicated medical claims, based on positive laboratory test results, procedures, and specific ICD-10 diagnosis codes associated with RSV. </p>

        <h4>Vulnerability of Respiratory Virus Activity</h4>
        <p>Cases are identified from adjudicated medical claims, based on specific ICD-10 diagnosis codes and lab test results associated with influenza, RSV, COVID-19, and additional respiratory viruses:</p>
        <ul>
          <li>Adenovirus</li>
          <li>Parainfluenza Virus (PIV)</li>
          <li>Human Metapneumovirus (HMPV)</li>
          <li>Rhinovirus</li>
          <li>Human Coronavirus (HCoV)</li>
        </ul>
        <h4>Allergies and Air Quality</h4>
        <p> Cases are identified from adjudicated medical claims, based on specific ICD-10 diagnosis codes associated with asthma, COPD, and allergies. Along with environmental data, the dashboard integrates spatial, temporal, and clinical data to support allergy/air quality data-driven decision-making.  </p>
        
        </div>
        
      </div>
    </div>
  )
}

export default DataSources
